import FolderSelectorComponent from './folder-selector';
import Config from './tree.config';

export {
    FolderSelectorComponent,
    Config
};



// WEBPACK FOOTER //
// ./app/common/tree/index.js